<ng-container *ngIf="url">
    <iframe #iframe title="Workspace" [src]="url | safeHtml: 'resourceUrl'" class="frame-container" (load)="loaded = true"></iframe>
    <div *ngIf="loaded" class="enable-fullscreen-btn" title="Enter Full-screen Mode" (click)="enableFullscreen(iframe)"></div>
</ng-container>
